import React, { useState } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { CreateReferralForm } from './CreateReferralForm';

interface DiscountHeaderProps {
  statusOptions?: string[];
  selectedSortStatus: string;
  selectedFilterStatus: string;
  setSelectedSortStatus: React.Dispatch<React.SetStateAction<string>>;
  setSelectedFilterStatus: React.Dispatch<React.SetStateAction<string>>;
}

interface SelectProps {
  value: string;
  onChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  options: string[];
  label: string;
}

const ReferralHeader: React.FC<DiscountHeaderProps> = ({
  statusOptions = [],
  selectedSortStatus,
  setSelectedSortStatus,
  selectedFilterStatus,
  setSelectedFilterStatus
}) => {
  const [openModal, setOpenModal] = useState(false);

  const handleCreateDiscount = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSubmit = (data) => {
    console.log('Discount submitted:', data);
    setOpenModal(false);
    // Here you would typically call an API to create the discount
  };

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h3" component="h3" gutterBottom>
            Referral
          </Typography>
          <Typography variant="subtitle2">
            Manage referral codes and promotional offers
          </Typography>
        </Grid>
        <Grid
          item
          display={'flex'}
          flexDirection={'column'}
          sx={{
            gap: '3'
          }}
        >
          <Grid item display={'flex'} justifyContent={'right'}>
            <Button
              sx={{ mt: { xs: 2, md: 0 } }}
              onClick={handleCreateDiscount}
              variant="contained"
              startIcon={<AddTwoToneIcon fontSize="small" />}
            >
              Create Referral
            </Button>
          </Grid>
          <Grid
            item
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{
              width: { xs: '100%', sm: 'auto' },
              minWidth: { sm: 400 },
              gap: 2,
              mt: { sm: 2 }
            }}
          >
            {statusOptions && statusOptions.length > 0 && (
              <>
                <FormControl fullWidth size="small">
                  <InputLabel>Filter by Status</InputLabel>
                  <Select
                    value={selectedFilterStatus}
                    onChange={(e) =>
                      setSelectedFilterStatus(e.target.value as string)
                    }
                    label="Filter by Status"
                  >
                    <MenuItem value="">All</MenuItem>
                    {statusOptions.map((status) => (
                      <MenuItem key={status} value={status}>
                        {status.replace(/_/g, ' ')}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>


              </>
            )}
          </Grid>
        </Grid>
      </Grid>

      <CreateReferralForm
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default ReferralHeader;
